import { ReportsActionTypes } from '../../actions/reports/reports.actions';
import { ListCardItem } from 'src/app/shared/components/cards/list-card/models/ListCardItem';

export interface ReportsState {
  reports: ListCardItem[];
  totalCount: string;
  report: ListCardItem;
  reportsLoading: boolean;
  reportLoading: boolean;
}

export const initialState: ReportsState = {
  reports: [],
  totalCount: null,
  report: null,
  reportsLoading: false,
  reportLoading: false
};

export function reportsReducer(
  state: ReportsState = initialState,
  action: any
): ReportsState {
  switch (action.type) {
    case ReportsActionTypes.GET_REPORTS:
      return {
        ...state,
        reportsLoading: true
      };
    case ReportsActionTypes.GET_REPORTS_SUCCESS:
      return {
        ...state,
        reportsLoading: false,
        reports: action.reports,
        totalCount: action.totalCount
      };
    case ReportsActionTypes.CLEAR_REPORTS:
      return {
        ...state,
        reportsLoading: false,
        reports: []
      };
    case ReportsActionTypes.GET_REPORT:
      return {
        ...state,
        reportLoading: true
      };
    case ReportsActionTypes.GET_REPORT_SUCCESS:
      return {
        ...state,
        report: action.report,
        reportLoading: false
      };
    case ReportsActionTypes.CLEAR_REPORT:
      return {
        ...state,
        reportLoading: false,
        report: null
      };
    default:
      return state;
  }
}
